import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { BottomNavComponent } from './bottom-nav/bottom-nav.component';
import { ToolbarLayoutComponent } from './toolbar-layout.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { BasicLayoutComponent } from './basic-layout.component';
import { NavbarComponent } from './navbar/navbar.component';
import { BlankLayoutComponent } from './blank-layout.component';
import { BottomLayoutComponent } from './bottom-layout.component';

const LAYOUT_COMPONENTS = [
  BottomNavComponent,
  ToolbarLayoutComponent,
  BasicLayoutComponent,
  BlankLayoutComponent, 
  BottomLayoutComponent
];

@NgModule({
  declarations: [
    BottomNavComponent,
    ToolbarComponent,
    NavbarComponent,
    BottomLayoutComponent,
    ...LAYOUT_COMPONENTS,
  ],
  imports: [
    // 共有モジュール
    SharedModule,
  ],
  exports: [
    ToolbarComponent,
    NavbarComponent,
    BottomLayoutComponent,
    ...LAYOUT_COMPONENTS,
  ],
})

export class LayoutModule { }
